import EpisodesDetail from "./EpisodesDetail";

export default EpisodesDetail;
